import { useLanguage, useTranslations } from "contexts/LocalizationContext";
import { ArrowRightIcon, ArrowIcon } from "styles/icons";
import NextLink from "next/link";
import { DEFAULT_STORY_AUTHOR } from "utils/serverSideUtils/consts";
import { getStoryLastUpdatedDate } from "utils/getStoryLastUpdatedDate";
import { Box, Text, Link } from "@chakra-ui/react";

import { PostListImage } from "./PostListImage";
import type { PostListItemProps } from "./PostListItem.d";

export const PostListItem = ({
  story,
  showImage = true,
  showExcerpt = true,
  showReadMore = true,
  showAuthor = true,
  showDate,
  isHero,
  fallbackFeaturedImage,
  ...props
}: PostListItemProps) => {
  const translations = useTranslations();
  const language = useLanguage();

  const {
    full_slug: fullSlug,
    name,
    content: { featuredImage, author },
  } = story;

  const lastUpdatedDate = showDate ? getStoryLastUpdatedDate(story, language) : "";
  const postTitle = `${name}${!showReadMore ? ArrowIcon : ""}`;

  const slug = fullSlug.split("/").slice(1).join("/");

  return (
    <Box mb={{ base: 12, lg: 24 }} {...props}>
      <Link as={NextLink} href={`/${language}/${slug}/`} passHref _hover={{ textDecoration: "none" }}>
        {showImage && <PostListImage src={featuredImage ?? fallbackFeaturedImage} alt={name} />}
        <Text
          mb={2}
          color="primary.900"
          fontWeight="bold"
          fontSize={isHero ? { base: "xl", md: "4xl" } : "xl"}
          lineHeight="1.2"
        >
          {postTitle}
        </Text>
        <Box mb={showExcerpt ? 4 : 2}>
          {showAuthor && (
            <>
              <Text fontSize="md" color="greyscale.500" textTransform="lowercase" display="inline">
                {translations("by_author_name")}
              </Text>
              <Text color="greyscale.500" fontSize="md" display="inline">{` ${author || DEFAULT_STORY_AUTHOR}`}</Text>
            </>
          )}
          {showDate && (
            <Text color="greyscale.500" fontSize="md">
              {lastUpdatedDate}
            </Text>
          )}
        </Box>
        {showReadMore && (
          <Text fontSize="lg" color="primary.500">
            {translations("read_more")} <ArrowRightIcon boxSize={4} ml={2} />
          </Text>
        )}
      </Link>
    </Box>
  );
};
